import { AnimationWithSize } from "./AnimationWithSize";

export const ProjectPlan = () => (
    <AnimationWithSize src="https://dam-cdn.atl.orangelogic.com/AssetLink/50miwctfdsfv7srn8cq3q65fs047esh8.riv" />
);
